"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { Debounce } from "vue-debounce-decorator";
let ConfigRoleMumbersDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.selectLock = false;
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    //   dialog = new UiDialogController();
    this.roleName = "";
    this.selectDatas = [];
    this.selectDepartment = null;
    this.departmentList = [];
    this.departmentProps = {
      value: "id",
      label: "label",
      children: "children",
      emitPath: false,
      checkStrictly: true
    };
    this.roleList = [];
    this.selectedRole = "";
    this.chooseTargetId = "";
    this.maxDepartmentTags = 3;
    this.searchStr = "";
    this.searchByName = _.debounce((searchStr) => __async(this, null, function* () {
      this.searchStr = searchStr != null ? searchStr : "";
      this.gridController.query.current = 1;
      yield this.checkSearch();
    }), 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
    this.gridController.query.params = {
      search: `userStatus=='0'`
    };
  }
  open(data) {
    return __async(this, null, function* () {
      this.searchStr = "";
      this.roleName = data.name;
      this.chooseTargetId = data.guid;
      this.selectDatas = [];
      this.selectDepartment = "all";
      this.selectedRole = "all";
      this.selectLock = false;
      yield this.getDepartmentTrees();
      yield this.getRoleList();
      this.gridController.query.sort = "asc";
      yield this.gridController.search();
      this._distributionConfigRoleMumbersDialog.setOptSpan(16, 8);
      this._distributionConfigRoleMumbersDialog.open();
      this.$nextTick(() => __async(this, null, function* () {
        yield this.getRoleMembers(data.guid);
        this.checkItem();
      }));
    });
  }
  // 获取当前角色下绑定的成员列表
  getRoleMembers(roleId) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/roles/${roleId}/users`);
        for (const item of response.data.datas) {
          let _item = {
            id: item.guid,
            label: `${item.name} (${this.getId(item.account)})`
          };
          this._distributionConfigRoleMumbersDialog.add(_item);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getRoleList() {
    return __async(this, null, function* () {
      try {
        const responst = yield API.get("api://base.auth/api/v1/roles");
        this.roleList = responst.data.datas;
        const allRoleItem = {
          id: "all",
          name: this.$t("vdbindadmin.all_roles")
        };
        this.roleList.unshift(allRoleItem);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartmentTrees() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        const formatData = (nodes) => {
          nodes.forEach((node) => {
            if (node.children && node.children.length > 0) {
              formatData(node.children);
            } else {
              delete node.children;
            }
          });
          return nodes;
        };
        let response = yield API.get(`api://base.auth/api/v7/departments`);
        const allDepartmentItem = {
          id: "all",
          label: this.$t("vdbindadmin.all_departments"),
          disabled: false
        };
        arr.push(allDepartmentItem);
        const rootDepartment = response.data;
        rootDepartment.disabled = true;
        arr.push(rootDepartment);
        formatData(arr);
        this.departmentList = arr;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeSelectRole(value) {
    this.selectedRole = value;
    this.gridController.query.current = 1;
    this.checkSearch();
  }
  changeSelectDepartment(value) {
    this.selectDepartment = value != null ? value : null;
    this.gridController.query.current = 1;
    this.checkSearch();
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
  checkItem() {
    let selectDatas = [];
    if (this._distributionConfigRoleMumbersDialog) {
      selectDatas = this._distributionConfigRoleMumbersDialog.getAll();
    }
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (selectData, data) => selectData.id == data.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  selectItems(items) {
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(
        this.gridController.result.datas,
        items,
        _.isEqual
      );
      for (const item of items) {
        const _item = {
          // id:item['guid'],
          id: item["id"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionConfigRoleMumbersDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          // id:item['guid'],
          id: item["id"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionConfigRoleMumbersDialog.del(_item);
      }
    }
  }
  updateSearchParams() {
    const conditions = [`userStatus=='0'`];
    if (this.searchStr) {
      conditions.push(
        `(name=='%${this.searchStr}%',account=='%${this.searchStr}%')`
      );
    }
    if (this.selectDepartment !== null && this.selectDepartment !== "" && this.selectDepartment !== void 0 && this.selectDepartment !== "all") {
      conditions.push(`departmentId=='${this.selectDepartment}'`);
    }
    if (this.selectedRole !== null && this.selectedRole !== "" && this.selectedRole !== void 0 && this.selectedRole !== "all") {
      conditions.push(`roleId=='${this.selectedRole}'`);
    }
    this.gridController.query.params = {
      search: conditions.join(";")
    };
  }
  checkSearch() {
    return __async(this, null, function* () {
      this.updateSearchParams();
      yield this.gridController.search();
    });
  }
  getDepartmentDisplay(departments) {
    const names = Array.isArray(departments) ? departments.map((item) => item && item.name ? item.name : "").filter((name) => !!name) : [];
    return {
      names: names.slice(0, this.maxDepartmentTags),
      hasMore: names.length > this.maxDepartmentTags
    };
  }
  changed(data) {
    let rows = _.differenceWith(
      this.selectDatas,
      data,
      (selectData, data2) => selectData.id == data2.id
    );
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  saved(data) {
    return __async(this, null, function* () {
      let userIds = _.map(data, "id");
      try {
        yield API.put(`api://base.auth/api/v1/roles/${this.chooseTargetId}/users`, {
          "users": userIds
        });
        this.$message.success(
          this.$t("shopbindadmin.binding_successful")
        );
        this._distributionConfigRoleMumbersDialog.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("distributionConfigRoleMumbersDialog")
], ConfigRoleMumbersDialog.prototype, "_distributionConfigRoleMumbersDialog", 2);
__decorateClass([
  Ref("multipleTable")
], ConfigRoleMumbersDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(400)
], ConfigRoleMumbersDialog.prototype, "saved", 1);
ConfigRoleMumbersDialog = __decorateClass([
  Component({
    components: {
      DistributionDialog,
      UiGrid
    }
  })
], ConfigRoleMumbersDialog);
export {
  ConfigRoleMumbersDialog as default
};
